

import {defineComponent, PropType} from "vue";

export const HeroTypeObj = {
  Hero1: 1,
  Hero2: 2,
  Hero3: 3,
  Hero4: 4,
  Hero5: 5,
  Hero6: 6
}

export type HeroType = keyof typeof HeroTypeObj;

export default defineComponent({
  name: "Hero",
  props: {
    type: {
      type: String as PropType<HeroType>,
      required: true
    },
    withFocusLine: {
      type: Boolean,
      default: true
    },
    id: {
      type: String,
      required: false
    },
  },
  render() {
    return (
      <a id={`${typeof this.$props.id !== 'undefined' ? this.$props.id : ''}`}>
      <h1 class={`hero hero--${HeroTypeObj[this.$props.type]}`}>
        {this.$props.withFocusLine && <div class="hero-focusline"/>}

        <div class="hero-text">
          {this.$slots.topline && <div class="hero-topline">
            {this.$slots.topline()}
          </div>}

          {this.$slots.default && this.$slots.default()}

          {this.$slots.description && <div class="hero-description">
            {this.$slots.description()}
          </div>}
        </div>
      </h1>
      </a>
    )
  }
})
